import { useState } from "react";
import ReactDOM from "react-dom";
import { IoCloseOutline } from "react-icons/io5";
import styled from "styled-components";
import countries from "../../../assets/store/countries";
import colors from "../../../theme/color/ColorTheme";
import fontSize from "../../../theme/fonts/FontTheme";
import {
  validateEmail,
  validatePassword,
  validateRequired,
} from "../../../utils/validators";
import { moveInRight } from "../../animations/MoveInRight";
import PrimaryButton from "../../buttons/PrimaryButton";
import UnderlineButton from "../../buttons/UnderlineButton";
import Dropdown from "../../input/Dropdown";
import TextField from "../../input/TextField";

const Wrapper = styled.div``;

const DimBackground = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1000;
`;

const Container = styled.div`
  position: fixed;
  top: 40px;
  right: 0;
  height: calc(100vh - 40px);
  width: 380px;
  max-width: 100%;
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 60px 40px -7px;
  animation: ${moveInRight} 0.35s ease forwards;
  padding: 25px;
  z-index: 2001;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow-y: auto;
`;

const CloseIcon = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  color: ${colors.primaryGray};
  font-size: 24px;
  cursor: pointer;
`;

const Title = styled.div`
  text-align: center;
  padding-bottom: 32px;
  color: ${colors.black};
  text-transform: uppercase;
  font-size: ${fontSize.s};
`;

const FormWrapper = styled.div`
  margin-top: 50px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const CheckboxWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;

  label {
    flex: 1;
    word-break: break-word;
    cursor: pointer;
    font-size: ${fontSize.xxs};
  }

  input[type="checkbox"] {
    width: 18px;
    height: 18px;
    appearance: none;
    border: 1px solid ${colors.border};
    cursor: pointer;
    position: relative;
    transition: all 0.2s ease;
  }

  input[type="checkbox"]:checked::before {
    content: "";
    position: absolute;
    top: 2px;
    left: 5px;
    width: 4px;
    height: 8px;
    border: solid ${colors.black};
    border-width: 0 1px 1px 0;
    transform: rotate(45deg);
  }
`;

const Login = styled.div`
  display: flex;
  margin-top: 16px;
  gap: 8px;

  p {
    color: ${colors.primaryGray};
    font-size: ${fontSize.xs};
  }
`;

function SideMenuAccountSignup({ onClose, openSignin }) {
  const [receiveMail, setReceiveMail] = useState(false);
  const [formValues, setFormValues] = useState({
    email: "",
    fullName: "",
    country: "",
    password: "",
  });
  const [errors, setErrors] = useState({});

  const handleChange = (field) => (e) => {
    setFormValues({ ...formValues, [field]: e.target.value });
  };

  const handleCheckboxChange = (e) => {
    setReceiveMail(e.target.checked);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const validationErrors = {
      email: validateEmail(formValues.email),
      fullName: validateRequired(formValues.fullName),
      country: validateRequired(formValues.country),
      password: validatePassword(formValues.password),
    };

    setErrors(validationErrors);

    if (!Object.values(validationErrors).some(Boolean)) {
      console.log("Form submitted:", { ...formValues, receiveMail });
      // call your API here
    }
  };

  return ReactDOM.createPortal(
    <Wrapper>
      <DimBackground onClick={onClose} />
      <Container>
        <CloseIcon onClick={onClose}>
          <IoCloseOutline />
        </CloseIcon>
        <FormWrapper>
          <Title>CREATE AN ACCOUNT TO ACCESS EXCLUSIVES AND MORE</Title>
          <Form onSubmit={handleSubmit}>
            <TextField
              text="EMAIL ADDRESS"
              value={formValues.email}
              error={errors.email}
              onChange={handleChange("email")}
            />
            <TextField
              text="FULL NAME"
              value={formValues.fullName}
              error={errors.fullName}
              onChange={handleChange("fullName")}
            />

            <Dropdown
              value={formValues.country}
              onChange={(val) => setFormValues({ ...formValues, country: val })}
              options={countries.map((c) => c.name)}
              placeholder="SELECT COUNTRY"
              error={errors.country}
            />
            <TextField
              text="PASSWORD"
              type="password"
              value={formValues.password}
              error={errors.password}
              onChange={handleChange("password")}
            />
            <CheckboxWrapper>
              <input
                type="checkbox"
                checked={receiveMail}
                onChange={handleCheckboxChange}
              />
              <label>
                Yes, I would like to receive updates about offers, collections
                and exclusives by email.
              </label>
            </CheckboxWrapper>
            <PrimaryButton type="submit" title="CONTINUE" />
          </Form>
        </FormWrapper>
        <Login>
          <p>Already have an account?</p>
          <UnderlineButton
            placeholder={"LOGIN"}
            onClick={() => {
              onClose();
              openSignin();
            }}
          />
        </Login>
      </Container>
    </Wrapper>,
    document.body
  );
}

export default SideMenuAccountSignup;
